import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QuizComponent } from './quiz.component';

const routes: Routes = [{
  path: 'quiz',
  component: QuizComponent,
  data: {
    title: 'Quiz'
  }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class QuizRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/quiz/quiz-routing.module.ts